export const CREATE_SCHOOL_REQUEST = 'CREATE_SCHOOL_REQUEST';
export const CREATE_SCHOOL_SUCCESS = 'CREATE_SCHOOL_SUCCESS';
export const CREATE_SCHOOL_FAILURE = 'CREATE_SCHOOL_FAILURE';

export const READ_SCHOOL_REQUEST = 'READ_SCHOOL_REQUEST';
export const READ_SCHOOL_SUCCESS = 'READ_SCHOOL_SUCCESS';
export const READ_SCHOOL_FAILURE = 'READ_SCHOOL_FAILURE';

export const UPDATE_SCHOOL_REQUEST = 'UPDATE_SCHOOL_REQUEST';
export const UPDATE_SCHOOL_SUCCESS = 'UPDATE_SCHOOL_SUCCESS';
export const UPDATE_SCHOOL_FAILURE = 'UPDATE_SCHOOL_FAILURE';

export const DELETE_SCHOOL_REQUEST = 'DELETE_SCHOOL_REQUEST';
export const DELETE_SCHOOL_SUCCESS = 'DELETE_SCHOOL_SUCCESS';
export const DELETE_SCHOOL_FAILURE = 'DELETE_SCHOOL_FAILURE';
